import { useTranslation } from 'react-i18next';
import { useLightningLayerEnabled } from 'features/mapping/hooks/useLightningLayerEnabled';
import { useLightningToolsState } from 'state/useLightningToolsState';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';
import { useAuthState } from 'state/useAuthState';

export const useLightningToolsCommandPaletteAction = (
  allowLightningControl: boolean,
): void => {
  const { showMembershipProFeatures } = useAuthState();
  const { showLightningLayer } = useLightningLayerEnabled();
  const { toggle } = useLightningToolsState();
  const { t } = useTranslation();

  useKeyboardShortcuts(
    showMembershipProFeatures && showLightningLayer && allowLightningControl
      ? [
          {
            category: 'mapTools',
            description: t('keyboardShortcuts.mapTools.lightningTools'),
            keys: 't i',
            handler: toggle,
          },
        ]
      : [],
    [
      showMembershipProFeatures,
      showLightningLayer,
      allowLightningControl,
      toggle,
    ],
  );
};
